/** @type {Styles} */
export const styles = {
  itemButton: {
    width: '100%',

    borderRadius: 1,

    justifyContent: 'initial',
    '& .MuiListItemIcon-root': {
      minWidth: 0,
      color: 'gray.64',
      margin: 0,
      padding: 0,
    },
    '& .MuiListItemText-primary': {
      color: 'gray.80',
    },
    '&:last-child': {
      marginBottom: 0,
    },
    '&:hover': {
      backgroundColor: 'primary.lightest',
      '& .MuiListItemIcon-root': {
        color: 'primary.main',
      },
      '& .MuiListItemText-primary': {
        color: 'primary.main',
      },
    },
  },
  itemIcon: {
    margin: 0,
    padding: 0,
  },
  bottomItemLabel: {
    margin: 0,
    marginLeft: 2.25,
    '& .MuiListItemText-primary': {
      fontWeight: 600,
      fontSize: 14,
      lineHeight: 2,
      margin: 0,
    },
  },
  menuPaper: {
    width: { xs: 'calc(100vw - 32px)', sm: 310 },
    maxHeight: { xs: '60vh', sm: 400 },
    marginTop: 6,
    boxShadow: 2,
    borderRadius: 2,

    '& .MuiList-root': {
      padding: 0,
    },
  },
  downloadButton: (open) => ({
    borderRadius: 1,
    border: 1,
    padding: 1,
    borderColor: 'gray.8',
    boxShadow: '0px 1px 2px 0px #0000000A',
    color: open ? 'primary' : 'gray.64',

    backgroundColor: 'gray.0',

    '& .MuiButton-endIcon': {
      margin: 0,
      padding: 0,
    },
  }),
  countBox: {
    bgcolor: 'primary.main',
    color: 'gray.0',
    fontWeight: 'bold',
    fontSize: '0.75rem',
    minWidth: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
  },
  actionsRow: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
  },
  supportButton: {
    borderRadius: '50%',
    border: 1,
    padding: 1,
    borderColor: 'gray.8',
    boxShadow: '0px 1px 2px 0px #0000000A',
    color: 'gray.64',
    backgroundColor: 'gray.0',
    '& .MuiButton-endIcon': {
      margin: 0,
      padding: 0,
    },
  },
}
